// extracted by mini-css-extract-plugin
module.exports = {"month":"Todo_month__1gvVD","monthpadding":"Todo_monthpadding__FBJwS","trBackground":"Todo_trBackground__39-3X","trColor":"Todo_trColor__34OF-","AddButton":"Todo_AddButton__10Nnv"};